import { render, staticRenderFns } from "./CalculatorV2.vue?vue&type=template&id=5bca2d6c&scoped=true"
import script from "./CalculatorV2.vue?vue&type=script&lang=js"
export * from "./CalculatorV2.vue?vue&type=script&lang=js"
import style0 from "./CalculatorV2.vue?vue&type=style&index=0&id=5bca2d6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bca2d6c",
  null
  
)

export default component.exports